var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"fade"}},[(_vm.show)?_c('div',{staticClass:"modal-container",on:{"click":function($event){return _vm.clickModal($event)}}},[_c('div',{staticClass:"modal"},[_c('i',{staticClass:"el-icon-close",staticStyle:{"cursor":"pointer"},on:{"click":_vm.closeModal}}),_vm._t("default")],2)]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }